import { render, staticRenderFns } from "./rulerGroupMark.vue?vue&type=template&id=454ee474&scoped=true"
import script from "./rulerGroupMark.vue?vue&type=script&lang=js"
export * from "./rulerGroupMark.vue?vue&type=script&lang=js"
import style0 from "./rulerGroupMark.vue?vue&type=style&index=0&id=454ee474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454ee474",
  null
  
)

export default component.exports